document.addEventListener("DOMContentLoaded", function () {
    // Add active class to the first tab
    document.querySelector(".tabs li:first-child")?.classList.add("active");
    document.querySelector(".tabs-content li:first-child")?.classList.add("active");
  
    // Get all tab links
    const tabLinks = document.querySelectorAll(".tabs li a");
  
    tabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // prevent default anchor behavior
  
        const tabId = this.getAttribute("href");
  
        // Remove active class from all tabs and content
        document.querySelectorAll(".tabs li").forEach(function (tab) {
          tab.classList.remove("active");
        });
  
        document.querySelectorAll(".tabs-content li").forEach(function (content) {
          content.classList.remove("active");
        });
  
        // Add active class to the clicked tab and corresponding content
        this.parentElement.classList.add("active");
        const target = document.querySelector(tabId);
        if (target) {
          target.classList.add("active");
        }
      });
    });
  });
  

// Peppi SKU prefix search: look up any hyphenated SKU without hardcoding its prefix.
(function () {
  function isSkuCandidate(term) {
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(term);
  }

  function fetchSkuProducts(term) {
    const params = new URLSearchParams({
      q: "variants.sku:" + term + "*",
      "resources[type]": "product",
      "resources[limit]": "5",
      "resources[options][fields]": "variants.sku"
    });
    return window.fetch(window.routes.searchUrl + "/suggest.json?" + params.toString(), {
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("SKU search request failed");
      return response.json();
    }).then(function (data) {
      return data.resources && data.resources.results && data.resources.results.products || [];
    });
  }

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes("/search")) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const term = input.value.trim();
    if (!isSkuCandidate(term)) return;

    event.preventDefault();
    const searchUrl = form.action;
    const normalSearch = searchUrl + "?type=product&q=" + encodeURIComponent(term);
    fetchSkuProducts(term).then(function (products) {
      const target = products.length && input.value.trim() === term
        ? searchUrl + "?type=product&q=" + encodeURIComponent("variants.sku:" + term + "*")
        : normalSearch;
      window.location.assign(target);
    }).catch(function () {
      window.location.assign(normalSearch);
    });
  }, true);

  let skuSearchRequest = 0;
  document.addEventListener("input", function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(".search-bar__input")) return;

    const term = input.value.trim();
    const requestId = ++skuSearchRequest;
    if (!isSkuCandidate(term)) return;

    window.setTimeout(function () {
      if (requestId !== skuSearchRequest || input.value.trim() !== term) return;

      const form = input.closest("form.search-bar");
      const results = form && form.querySelector(".search-bar__results");
      const resultsInner = form && form.querySelector(".search-bar__results-inner");
      if (!results || !resultsInner) return;

      fetchSkuProducts(term).then(function (products) {
        if (requestId !== skuSearchRequest || input.value.trim() !== term || !products.length) return;

        resultsInner.replaceChildren();

        const heading = document.createElement("p");
        heading.className = "search-bar__result-category";
        heading.textContent = "Termékek";
        resultsInner.appendChild(heading);

        const productList = document.createElement("div");
        productList.className = "search-bar__result-products";
        products.forEach(function (product) {
          const item = document.createElement("a");
          item.href = product.url;
          item.className = "search-bar__result-item";

          const imageContainer = document.createElement("div");
          imageContainer.className = "search-bar__image-container";
          const ratio = document.createElement("div");
          ratio.className = "aspect-ratio aspect-ratio--square";
          if (product.featured_image && product.featured_image.url) {
            const image = document.createElement("img");
            image.src = product.featured_image.url;
            image.alt = product.featured_image.alt || "";
            ratio.appendChild(image);
          }
          imageContainer.appendChild(ratio);
          item.appendChild(imageContainer);

          const info = document.createElement("div");
          info.className = "search-bar__item-info";
          const title = document.createElement("p");
          title.className = "search-bar__item-title";
          title.textContent = product.title;
          info.appendChild(title);

          if (product.price != null) {
            const price = document.createElement("span");
            price.className = "search-bar__item-price";
            price.textContent = new Intl.NumberFormat("hu-HU", {
              style: "currency", currency: "HUF", maximumFractionDigits: 0
            }).format(Number(product.price));
            info.appendChild(price);
          }
          item.appendChild(info);
          productList.appendChild(item);
        });
        resultsInner.appendChild(productList);
        results.setAttribute("aria-hidden", "false");
      }).catch(function () {
        // Keep the theme's standard suggestions if the SKU request fails.
      });
    }, 450);
  }, true);
})();
